import React from "react";
import PropTypes from "prop-types";
import "./LoadingMessage.css";

const bars = [
  { animationDelay: "-1.2s", transform: "rotate(.0001deg) translate(146%)" },
  { animationDelay: "-1.1s", transform: "rotate(30deg) translate(146%)" },
  { animationDelay: "-1.0s", transform: "rotate(60deg) translate(146%)" },
  { animationDelay: "-0.9s", transform: "rotate(90deg) translate(146%)" },
  { animationDelay: "-0.8s", transform: "rotate(120deg) translate(146%)" },
  { animationDelay: "-0.7s", transform: "rotate(150deg) translate(146%)" },
  { animationDelay: "-0.6s", transform: "rotate(180deg) translate(146%)" },
  { animationDelay: "-0.5s", transform: "rotate(210deg) translate(146%)" },
  { animationDelay: "-0.4s", transform: "rotate(240deg) translate(146%)" },
  { animationDelay: "-0.3s", transform: "rotate(270deg) translate(146%)" },
  { animationDelay: "-0.2s", transform: "rotate(300deg) translate(146%)" },
  { animationDelay: "-0.1s", transform: "rotate(330deg) translate(146%)" },
];

const LoadingMessage = ({ size = 64 }) => {
  return (
    <div className="wrapper">
      <div className="spinner-container" style={{ width: size, height: size }}>
        {bars.map((item) => (
          <div
            key={item.transform}
            className="spinner-bar"
            style={{
              animationDelay: item.animationDelay,
              transform: item.transform,
            }}
          />
        ))}
      </div>
    </div>
  );
};

LoadingMessage.propTypes = {
  size: PropTypes.number,
};

export default LoadingMessage;

